function touchscreen() {
  return 'ontouchstart' in window || navigator.maxTouchPoints
}

export function mouseover() { return 'mouseover' }
export function mouseleave() { return 'mouseleave' }
export function mouseout() { return 'mouseout' }

export function click() {
  if (touchscreen()) {
    return 'dblclick'
  }
  return 'click'
}



// WEBPACK FOOTER //
// ./src/components/mixins/compat.js